<template>

	<section class="full-width no-padding-top" id="goals-settings" v-bind:class="{'no-goals': no_goals}">

		<div class="container">

			<div class="row heading">

				<div class="col-12">
					<h2>My health goals</h2>
				</div>

			</div>

			<div class="row progress" id="goal-progress-wrapper" v-if="!questionnaire">

				<div class="col-12">

					<h3>This week's progress</h3>
					<goal-progress ref="goal-progress"></goal-progress>

				</div>

			</div>

			<div class="row goal question" id="set-goals-question" v-show="!questionnaire">

				<div class="col-12">

					<h3>Would you like to opt out of goals?</h3>

					<div class="inline-fields"><input v-model="no_goals" type="checkbox"><label>I don't want to set goals</label></div>

				</div>

			</div>

			<div class="row goal question" v-show="!questionnaire || question === 1">

				<div class="col-12">

					<h3>My food prep goal</h3>

					<div class="goal-input-wrapper">

						<div class="text">I want to cook</div>

						<div class="input">

							<button v-bind:disabled="thinking" class="input-control input-down" @click="decrease_recipe_goal()">-</button>
							<input class="goal-input" type="number" step="1" max="this.weekly_limit" min="0" v-model.number="recipe_goal">
							<button v-bind:disabled="thinking" class="input-control input-up" @click="increase_recipe_goal()">+</button>

						</div>

						<div class="text">times a week</div>

					</div>

				</div>

			</div>

			<div class="row goal question" v-show="!questionnaire || question === 2">

				<div class="col-12">

					<h3>I want to exercise on these days:</h3>

					<div class="goal-input-wrapper">

						<!-- <input readonly class="goal-input" type="number" step="1" max="this.weekly_limit" min="0" v-model.number="move_goal"> -->

						<!-- <div class="text">times a week</div> -->

					</div>

					<div class="day-selection-wrapper">

						<div class="day">
							<label>M</label>
							<input v-model="exercise_goal.mon" type="checkbox">
						</div>
						<div class="day">
							<label>T</label>
							<input v-model="exercise_goal.tues" type="checkbox">
						</div>
						<div class="day">
							<label>W</label>
							<input v-model="exercise_goal.wed" type="checkbox">
						</div>
						<div class="day">
							<label>T</label>
							<input v-model="exercise_goal.thurs" type="checkbox">
						</div>
						<div class="day">
							<label>F</label>
							<input v-model="exercise_goal.fri" type="checkbox">
						</div>
						<div class="day">
							<label>S</label>
							<input v-model="exercise_goal.sat" type="checkbox">
						</div>
						<div class="day">
							<label>S</label>
							<input v-model="exercise_goal.sun" type="checkbox">
						</div>

					</div>

				</div>

			</div>

			<div class="row goal question" v-show="!questionnaire || question === 3">

				<div class="col-12">

					<h3>I would like to try these type of exercises:</h3>

					<div class="exercise-preference-wrapper">

						<div class="inline-fields"><input v-model="exercise_prefs.pilates" type="checkbox"><label>Pilates</label></div>
						<div class="inline-fields"><input v-model="exercise_prefs.yoga" type="checkbox"><label>Yoga</label></div>
						<div class="inline-fields"><input v-model="exercise_prefs.bounce" type="checkbox"><label>Strength</label></div>
						<div class="inline-fields"><input v-model="exercise_prefs.strength" type="checkbox"><label>Bounce</label></div>

					</div>

				</div>

			</div>

			<div class="row goal question" v-show="!questionnaire || question === 4">

				<div class="col-12">

				<h3>What do you need the most support with?</h3>

					<select class="core-prevent-select2 select-css" v-model="support_prefs">

						<option disabled value="">Please select one</option>
						<option value="emotional-eating">Emotional eating</option>
						<option value="cravings">Cravings</option>
						<option value="body-image">Body image</option>
						<option value="getting-fit">Getting fit and strong</option>
						<option value="low-energy">Low energy</option>

					</select>

				</div>

			</div>

			<div class="row">

				<div class="col-12">

					<button class="core-btn" v-bind:disabled="thinking" v-if="questionnaire && this.question <= this.numberOfQuestions" @click="prevQuestion()">Previous</button>
					<button class="core-btn" v-bind:disabled="thinking" v-if="questionnaire && this.question <= this.numberOfQuestions" @click="nextQuestion()">Next</button>
					<button v-if="!questionnaire" v-bind:disabled="thinking" class="core-btn" @click="saveGoals()">Save goals</button>

				</div>

			</div>

		</div>

	</section>

</template>

<script>

	import GoalProgress from '../components/goal-progress.vue';
	import VueSvgGauge from 'vue-svg-gauge';

	Vue.use(VueSvgGauge);

	export default {

		name: 'goals-settings',

		components: {

			GoalProgress
		},

		data() {

			return {

				thinking: false,

				user_id: coreHelpers.getNested(pageData, 'user_profile', 'user_id'),

				weekly_limit: 7,

				move_goal: 3,

				exercise_goal: {

					mon: false,
					tues: false,
					wed: false,
					thurs: false,
					fri: false,
					sat: false,
					sun: false,

				},

				exercise_prefs: {

					pilates: false,
					yoga: false,
					bounce: false,
					strength: false,

				},

				recipe_goal: coreHelpers.getNested(pageData, 'goals', 'data', 'recipe_goal') ? parseInt(window.pageData.goals.data.recipe_goal) : 3,
				no_goals: coreHelpers.getNested(pageData, 'goals', 'data', 'no_goals') === 'true' ? true : false,
				support_prefs: coreHelpers.getNested(pageData, 'goals', 'data', 'support_prefs') ? pageData.goals.data.support_prefs : '',

				numberOfQuestions: null,

			}

		},

		props: {

			questionnaire: {

				default: false,
				type: Boolean,

			},
			question: {

				default: 1,
				type: Number,

			},

		},

		mounted() {

			this.numberOfQuestions = document.querySelectorAll('.question.goal').length - 1;

			if (coreHelpers.getNested(pageData,'goals', 'data', 'exercise_goal')) {

				this.exercise_goal = this.convert_nested_string_to_boolean(pageData.goals.data.exercise_goal);

			}

			this.move_goal = this.count_days_object(this.exercise_goal);

			if (coreHelpers.getNested(pageData,'exercise_prefs')) {

				this.exercise_prefs = this.convert_nested_string_to_boolean(coreHelpers.getNested(pageData,'exercise_prefs'));

			}

		},

		watch: {

			exercise_goal: {

				handler(exercise_goal) {

					this.move_goal = this.count_days_object(exercise_goal);

				},
				deep: true
			},

		},

		methods: {

			nextQuestion() {

				window.questionnaire.next();

				if (this.question === this.numberOfQuestions) {

					this.saveGoals();

				}
			},

			prevQuestion() {

				window.questionnaire.prev();

			},

			convert_nested_string_to_boolean(object) {

				// return object;
				for (const [key, value] of Object.entries(object)) {

					if (value === 'true') {

						object[key] = true;

					}
					else {

						object[key] = false;

					}

				}

				return object;

			},

			count_days_object(days) {

				return Object.values(days).filter(day => day === true).length;

			},

			increase_recipe_goal() {

				this.recipe_goal++;

				if (this.recipe_goal > this.weekly_limit) {

					this.recipe_goal = this.weekly_limit;

				}

			},

			decrease_recipe_goal() {

				this.recipe_goal--;

				if (this.recipe_goal < 1) {

					this.recipe_goal = 0;

				}

			},

			saveGoals() {

				this.thinking = true;

				window.coreHelpers.ajax.call(this, 'POST', 'lc_save_goal_prefs', {

					'exercise_goal': this.exercise_goal,
					'recipe_goal': this.recipe_goal,
					'exercise_prefs': this.exercise_prefs,
					'no_goals': this.no_goals,
					'support_prefs': this.support_prefs,

				}, function(res) {

					this.thinking = false;

					document.cookie = "lc_goals= ; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";

					if(!this.questionnaire) {

						coreVariables.triggerModal('Success', 'Your goals have been saved');

						if(coreHelpers.getNested(res, 'data', 'updated_data', ':goals')) {

							this.$refs['goal-progress']['goals'] = coreHelpers.getNested(res, 'data', 'updated_data', ':goals');

						}

					}
					else {

						//trigger the questionnaire completion
						window.questionnaire.completed();
					}

				}, function(res) {

					this.thinking = false;
					coreVariables.triggerModal('Slight issue', 'We could not save your goals, please try again later');

				});

			},
		},
	}
</script>